import { create } from 'zustand';

interface AuthState {
	name: string;
	pk: string;
	memberType: string;
	setPk: (pk: string) => void;
	setName: (name: string) => void;
	setMemberType: (memberType: string) => void;
	clearValues: () => void;
}

const getInitialValues = (): { name: string; pk: string; memberType: string } => {
	try {
		const authData = localStorage.getItem('auth');
		return authData ? JSON.parse(authData) : { name: '', pk: '', memberType: '' };
	} catch (error) {
		console.error('Failed to parse auth data from localStorage:', error);
		return { name: '', pk: '', memberType: '' };
	}
};

export const useAuthStore = create<AuthState>((set, get) => ({
	...getInitialValues(),

	setName: (name) => {
		const { pk, memberType } = get();
		set({ name });
		localStorage.setItem('auth', JSON.stringify({ name, pk, memberType }));
	},

	setPk: (pk) => {
		const { name, memberType } = get();
		set({ pk });
		localStorage.setItem('auth', JSON.stringify({ name, pk, memberType }));
	},

	setMemberType: (memberType) => {
		const { name, pk } = get();
		set({ memberType });
		localStorage.setItem('auth', JSON.stringify({ name, pk, memberType }));
	},

	clearValues: () => {
		set({ name: '', pk: '', memberType: '' });
		localStorage.removeItem('auth');
	},
}));
